import DatabaseModel from './DatabaseModel.js';

var Municipio = Object.create(DatabaseModel);

Municipio.model = 'municipio';
Municipio.modelFront = 'municipios';

export default Municipio;